import React from "react";

import axiosInstance from "../apis/gvmdesk";
import useAxiosFunction from "../hooks/useAxiosFunction";

//Components
import {
  Input,
  Button,
  Textarea
} from "../components";

import {
  useForm
} from "react-hook-form";

import {
  yupResolver
} from "@hookform/resolvers/yup";

import * as yup from "yup";

const schema = yup.object({
  command: yup.string().required("O campo comando precisa ser preenchido!").matches(/^\S+$/, "O comando não pode conter espaços em branco."),
  body: yup.string().required("O campo texto precisa ser preenchido!")
}).required();

export default function NewPreset() {
  const { register, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(schema) });

  const [response, setResponse, loading, error, axiosFetch] = useAxiosFunction();

  async function onSubmit(data) {
    axiosFetch({
      axiosInstance,
      method: "POST",
      url: "/presets",
      redirect_to: "/utils/presets",
      data: data
    });
  };

  return (
    <div className="u-d-flex flex-column justify-content-center align-center u-mt-100">
      <div className="white-box mt-1">

        <form onSubmit={handleSubmit(onSubmit)}>
          <Input
            label="Comando do preset"
            type="text"
            placeholder="mensagem_de_tudo_bem"
            name="command"
            register={register}
            error={errors.command}
          />

          <Textarea
            label="Texto"
            type="text"
            placeholder="Olá, tudo bem? [...]"
            name="body"
            register={register}
            error={errors.body}
          />

          <Button
            title="Criar novo preset"
            color="green"
            width="full"
            styles="mt-20"
            loading={loading}
          />
        </form>
      </div>
    </div>
  );
}